const theme = {
    mainColor: '#A5E5FF',
    blueColor:'#2689F2',
    backgroundColor: '#FFFFFF', 
    lightgrayColor: 'rgba(0, 0, 0, 0.05)', // 옅은 회색 : 리뷰 별에 사용
    darkgrayColor: 'rgba(0, 0, 0, 0.1)', // 아주조금 더 진한 회색 : 그 외 
    fonts: {
        light: 'NanumSquareNeoLight',
        regular: 'NanumSquareNeo',
        bold: 'NanumSquareNeoBold',
        extrabold: 'NanumSquareNeoExtraBold',
        heavy: 'NanumSquareNeoHeavy',
      },
};

export default theme;